export const commonLabels = {
  maintenanceMode: {
    title: "This site is under maintenance",
    description: (
      <>
        We are performing scheduled maintenance.
        <br />
        We will be back online shortly!
      </>
    ),
  },
  actions: {
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    update: "Update",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    undo: "Undo",
    complete: "Complete",
    discard: "Discard",
    back: "Back",
    request: "Request",
    submit: "Submit",
    reopen: "Reopen",
    replace: "Replace",
    review: "Review",
    confirm: "Confirm",
    requestCollaboration: "Request collaboration",
    collaborationRequested: "Collaboration requested",
    showEmissionFactors: "Show emission factors",
    showInternalComment: "Show internal comment",
  },
  notification: {
    successTitle: "Success",
    errorTitle: "Error",
  },
  navigation: {
    dashboard: "Dashboard",
    logout: "Logout",
    settings: "Settings",
    customers: "Customers",
    home: "Home",
    calculate: "Calculate",
    ccf: "Corporate Carbon Footprint",
    pcf: "Product Carbon Footprint",
    result: "Result",
    viewAllCalculations: "View all calculations",
  },
  fileUploader: {
    dragDropFiles: (
      <>
        Drag & drop files here <br /> or
      </>
    ),
    browseFilesButton: "Browse files",
  },
  unsavedDataWarning: {
    content:
      "By leaving this page, your changes will be lost. You can return to the page and save your data, or you can continue and discard changes.",
    title: "You have unsaved data",
    stay: "Stay on page",
    leave: "Leave page",
  },
  unitSelector: {
    ariaLabel: "Emission unit",
  },
  unit: {
    area: {
      ft2: "ft²",
      m2: "m²",
      ha: "ha",
    },
    label: "Unit",
    length: {
      cm: "cm",
      ft: "ft",
      in: "in",
      km: "km",
      m: "m",
      mi: "mi",
      yd: "yd",
    },
    mass: {
      g: "g",
      kg: "kg",
      lb: "lb",
      oz: "oz",
      t: "t",
      ton: "T (Short ton, US)",
    },
    piece: {
      pc: "Piece",
    },
    power: {
      kwh: "kWh",
      gCO2PerKwh: "g CO₂/kWh",
      MJ: "MJ",
    },
    volume: {
      floz: "fl. oz",
      gal: "gal (US)",
      l: "l",
      m3: "m³",
      ml: "ml",
      pt: "pt",
      cubicfoot: "cubic foot",
    },
    tCO2e: "t CO₂e",
    kgCO2e: "kg CO₂e",
    data: {
      mib: "MB",
      gib: "GB",
      tib: "TB",
      pib: "PB",
    },
    transport: {
      pkm: "pkm",
      vkm: "vkm",
    },
    tkm: "tkm",
    kwp: "kWp",
    employeeCommuting: {
      employeePerYear: "Employee/Year",
      employeePerDay: "Employee/Day",
      employeePerHour: "Employee/Hour",
    },
    night: "Night",
    day: "Day",
    currency: {
      eur: "€",
      usd: "$",
      gbp: "£",
      chf: "CHF",
      jpy: "¥",
      bgn: "лв",
      czk: "Kč",
      dkk: "kr (DKK)",
      huf: "Ft",
      pln: "zł",
      ron: "lei",
      nok: "kr (NOK)",
      sek: "kr (SEK)",
      hrk: "kn",
      rub: "₽",
      trl: "₺", // 'try' is a reserved keyword in JavaScript, so we use 'trl' as the key for Turkish Lira
      aud: "AU$",
      brl: "R$",
      cad: "CA$",
      cny: "¥ (CNY)",
      idr: "Rp",
      inr: "₹",
      krw: "₩",
      myr: "RM",
      zar: "R",
    },
    flight: "Flight",
    participant: "Participant",
    participantHour: "Participant/Hour",
    perAction: "Per Action",
    perHour: "Per Hour",
    websitePageView: "Website Page View",
    employee: "Employee",
    massPerDay: "Mass/Day",
    lengthPerYear: {
      km_per_year: "km/year",
      m_per_year: "m/year",
    },
    areaPerYear: {
      m2_per_year: "m²/year",
    },
  },
  defaultValues: "Default Values",
  genericErrorMessage: "Something went wrong. Please try again later.",
  comingSoon: "Coming soon",
  notEnabled: "Not included in your current plan",
};
